import React from 'react';
import {render} from 'react-dom';
import FontAwesome from '@fortawesome/fontawesome';
import FontAwesomeBrands from '@fortawesome/fontawesome-free-brands';
import FontAwesomeSolid from '@fortawesome/fontawesome-free-solid';
import FontAwesomeRegular from '@fortawesome/fontawesome-free-regular';
import '../scss/application.scss'
import App from './App/App'

FontAwesome.library.add(FontAwesomeBrands, FontAwesomeSolid, FontAwesomeRegular);
render(<App/>, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/js/index.js